module.exports = __webpack_public_path__ + "static/003-fccb8c00cf55b6285e7662ca6b1f10a7.jpg";